export const estados = [
  { value: '', text: 'Selecione' },
  { value: 'AC', text: 'Acre' },
  { value: 'AL', text: 'Alagoa' },
  { value: 'AP', text: 'Amapá' },
  { value: 'AM', text: 'Amazona' },
  { value: 'BA', text: 'Bahia ' },
  { value: 'CE', text: 'Ceará' },
  { value: 'ES', text: 'Espíri Santo' },
  { value: 'GO', text: 'Goiás' },
  { value: 'MA', text: 'Maranhão' },
  { value: 'MT', text: 'Mato Grosso' },
  { value: 'MS', text: 'Mato Grosso do Sul' },
  { value: 'MG', text: 'Minas Gerais' },
  { value: 'PA', text: 'Pará' },
  { value: 'PB', text: 'Paraíba' },
  { value: 'PR', text: 'Paraná' },
  { value: 'PE', text: 'Pernambuco' },
  { value: 'PI', text: 'Piauí' },
  { value: 'RJ', text: 'Rio de Janeiro' },
  { value: 'RN', text: 'Rio Grde do Norte' },
  { value: 'RS', text: 'Rio Grde do Sul' },
  { value: 'RO', text: 'Rondônia' },
  { value: 'RR', text: 'Roraima' },
  { value: 'SC', text: 'Santa catarina' },
  { value: 'SP', text: 'São Paulo' },
  { value: 'SE', text: 'Sergipe' },
  { value: 'TO', text: 'Tocantins' },
  { value: 'DF', text: 'Distri Federal' },
]

export const maskCrditCardNumber = [
  {
    mask: '0000 000000 0000',
    maxLength: 14,
  },
  {
    mask: '0000 000000 00000',
    maxLength: 15,
  },
  {
    mask: '0000 0000 0000 0000',
  },
]
